module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_SUPPORT', this.lang)))])])], 1), _vm._v(" "), (_vm.notSentError) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_MESSAGE_NOT_SENT', this.lang)))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.notSent) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-form-textarea', {
    ref: "myMessage",
    staticClass: "mb-3",
    attrs: {
      "id": "myMessage",
      "placeholder": _vm.$t('LNG_YOUR_MESSAGE', this.lang),
      "rows": 10,
      "max-rows": 100
    },
    model: {
      value: (_vm.myMessage),
      callback: function($$v) {
        _vm.myMessage = $$v
      },
      expression: "myMessage"
    }
  }), _vm._v(" "), _c('vue-recaptcha', {
    attrs: {
      "sitekey": "6Lc6FFoUAAAAACPewmO49WouIZm6Jmim6TKKLLcE"
    },
    on: {
      "verify": _vm.okC
    }
  }), _vm._v(" "), (_vm.displaySendMessage) ? _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_SEND', _vm.lang)))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.notSent) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_MESSAGE_SENT', this.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c2bb060"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/support.vue
// module id = 875
// module chunks = 1